import { render, staticRenderFns } from "./sitenav.vue?vue&type=template&id=88f3ca2c&scoped=true"
import script from "./sitenav.vue?vue&type=script&lang=js"
export * from "./sitenav.vue?vue&type=script&lang=js"
import style0 from "./sitenav.vue?vue&type=style&index=0&id=88f3ca2c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88f3ca2c",
  null
  
)

export default component.exports